export const TABLE_ROW_PER_PAGE = 10
export const TABLE_PAGINATION_DROPDOWN = [10, 20, 30, 40, 50]
export const SOMETHING_ERR = "Something wen't wrong"
export const SERVER_ERR = "Something wen't wrong"
export const FB_APP_ID = "1143179496737523"

export const GOOGLE_CLIENT_ID = "515789039948-k7bfdv1ai2khm1m7u50jeupfie16e69n.apps.googleusercontent.com"

export const searchOptions = {
  componentRestrictions: { country: "US" }
};

const IS_LIVE = true;

export const STRIPE_Publishable_KEY = IS_LIVE
  ? "pk_live_51RpleDGqc2NoyZhbmBfZtlHHgXPd9vgbKUqezwAbrn7kYyeAjnQDfGhYFc6QnhSfF9Rb8ez1brJCvzZ6tG6NsEct00OqATUg82"
  : "pk_test_51RpleMK3QqUXyjF9lAXqa5PaOhFVoOSIxi6bRhOUnRKHLw0JTfqPSVViexqvqLx18bZMNKjYQDCW39CXpXfO8FUs00lu7h2xpi";


export const WEBSITE_LOGO = "/static/media/logo-header.82d50b78dc84a2581340.png"
export const LINKEDIN_CLIENT_ID = "78bf558i1xhl2l";
export const LINKEDIN_REDIRECT_URI = "https://bluebridgecorporation.com/login";
// export const LINKEDIN_REDIRECT_URI = "https://humanoid.itworkshop.in/login";
export const LINKEDIN_SCOPE = "openid profile email";